import { AlertTriangle, CheckCircle2, Users, XCircle, Ticket } from 'lucide-react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import type { EventoStats } from '../types'

interface EventStatsCardProps {
  stats: EventoStats
}

export function EventStatsCard({ stats }: EventStatsCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <Ticket className="h-5 w-5 text-primary" />
          Panorama de Inscrições
        </CardTitle>
        <CardDescription>Resumo rápido das confirmações</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid gap-3">
          <div className="rounded-lg border p-3">
            <div className="flex items-center justify-between">
              <span className="text-xs text-muted-foreground">Inscrições totais</span>
              <Users className="h-4 w-4 text-primary" />
            </div>
            <p className="mt-2 text-2xl font-semibold">{stats.total}</p>
          </div>
          <div className="rounded-lg border p-3">
            <div className="flex items-center justify-between">
              <span className="text-xs text-muted-foreground">Confirmados</span>
              <CheckCircle2 className="h-4 w-4 text-emerald-500" />
            </div>
            <p className="mt-2 text-2xl font-semibold text-emerald-600">{stats.confirmados}</p>
            <p className="text-xs text-muted-foreground">
              Taxa de confirmação: {stats.taxaConfirmacao.toFixed(1)}%
            </p>
          </div>
          <div className="rounded-lg border p-3">
            <div className="flex items-center justify-between">
              <span className="text-xs text-muted-foreground">Pendentes</span>
              <AlertTriangle className="h-4 w-4 text-amber-500" />
            </div>
            <p className="mt-2 text-2xl font-semibold text-amber-600">{stats.pendentes}</p>
          </div>
          <div className="rounded-lg border p-3">
            <div className="flex items-center justify-between">
              <span className="text-xs text-muted-foreground">Cancelados</span>
              <XCircle className="h-4 w-4 text-rose-500" />
            </div>
            <p className="mt-2 text-2xl font-semibold text-rose-600">{stats.cancelados}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
